/* OsmOptionsComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./OsmOptionsRenderer");
const _ = require("lodash");

const READONLYSTATUS = ["CANCELED", "COMPLETE", "ERROR", "RUNNING", "VALIDATING"];

class OsmOptionsComponent extends EventEmitter {
    constructor(osPlanDetailsViewModel) {
        super();
        this._osPlanDetailsViewModel = osPlanDetailsViewModel;
        this._orgId = this._osPlanDetailsViewModel._gameEditor.activeOrgId;
        this._muf = this._osPlanDetailsViewModel._modalUserFeedback;
        this._logger = this._osPlanDetailsViewModel._logger;
        this._gameEditor = this._osPlanDetailsViewModel._gameEditor;
        this._osPlanEntity = this._osPlanDetailsViewModel._gameEditor.planEntity;
        this._plan = this._osPlanDetailsViewModel._gameEditor.getPlan();
        this._isReadOnly = false;
        if (READONLYSTATUS.indexOf(this._plan.status) >= 0) {
            this._isReadOnly = true;
        }
        this._osmOptionEntities = this._osPlanDetailsViewModel._osmOptionEntities;
        this._vendorOsMap = this._osPlanDetailsViewModel._vendorOsMap;
        this._executionEntity = this._osPlanDetailsViewModel._planExecutionEntity;
        this._osmOptions = {};
        this.generateOsmOptions();
        this._renderer = new Renderer(this);
        this._registerListeners();
        this._renderer.render();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    get logger() {
        return this._logger;
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(
            () => {
                this._osPlanDetailsViewModel = undefined;
                this._logger = undefined;
                this._gameEditor = undefined;
                this._osPlanEntity = undefined;
                this._plan = undefined;
                this._isReadOnly = undefined;
                this._osmOptionEntities = undefined;
                this._vendorOsMap = undefined;
                this._executionEntity = undefined;
                this._osmOptions = undefined;
                this._logger = undefined;
                this._renderer = undefined;
            },
            (err) => {
                this._logger.warn({error: err}, "OsmOptionsComponent.shutdown() error.");
            }
        );
    }

    // prettier-ignore
    set "$teve.ui.context" (context) { //jshint ignore:line
        this._context = context;
    }

    saveAction(result) {
        return this._osPlanEntity
            .loadOsUpgradePlan(this._orgId, this._plan.id)
            .then((cleanOsPlan) => {
                cleanOsPlan.setOsmOptions(this._plan.getOsmOptions());
                this._plan.setStatus("DRAFT");
                cleanOsPlan.setStatus("DRAFT");
                return cleanOsPlan.update();
            })
            .then(() => {
                this._context.resolve(result);
            })
            .catch((err) => {
                this._logger.warn({error: err}, "OsmOptionsComponent.saveAction() error.");
                this._muf.displayError(err);
                return Promise.reject();
            });
    }

    cancelAction() {
        this._context.reject({userRejected: true});
    }

    generateOsmOptions() {
        this._osmOptions = this._osmOptionEntities.reduce((acc, ety) => {
            const vendor = ety.vendor;
            const os = ety.os;
            const jtype = ety.jtype;
            if (!acc[vendor]) {
                acc[vendor] = {};
            }
            if (!acc[vendor][os]) {
                acc[vendor][os] = {};
            }
            acc[vendor][os] = jtype;
            return acc;
        }, {});
        // Merging options from execution entity for now
        if (this._executionEntity) {
            const execJtypes = _.get(
                this._executionEntity,
                "_pristineProperties.osmOptionJTypes",
                {}
            );
            if (execJtypes.vendorOsOptions) {
                this._osmOptions = _.defaultsDeep({}, execJtypes.vendorOsOptions, this._osmOptions);
            }
            if (execJtypes.commonOptions) {
                _.set(this._osmOptions, "*.*", execJtypes.commonOptions);
            }
        }
        // this.generateOsmOptionsVendorDDOpts();
    }

    generateOsmOptionsVendorDDOpts() {
        const vendorsList = Object.keys(this._osmOptions).sort();
        const vendorMap = this._vendorOsMap.extractVendorMapFromVendorOsMap();
        const vendorDDopts = vendorsList.map((vendor) => {
            return {
                value: vendor,
                label: vendor === "*" ? "All" : vendorMap[vendor] || vendor,
            };
        });
        // vendorsList.forEach(vendor => this.generateOsmOptionsOsDDOpts(vendor));
        return vendorDDopts;
    }

    generateOsmOptionsOsDDOpts(vendor) {
        if (!vendor) {
            return {};
        }
        const vendorData = this._osmOptions[vendor];
        const osList = Object.keys(vendorData);
        const osMap = this._vendorOsMap.extractOsMapFromVendorOsMap();
        const osDDOpts = osList.map((os) => {
            return {
                value: os,
                label: os === "*" ? "All" : osMap[os] || os,
            };
        });
        return osDDOpts;
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = OsmOptionsComponent;
